import Vue from 'vue';
import EditDeleteGroup from './EditDeleteGroup';
import SimpleTable from './SimpleTable';
import IconSelector from "./IconSelector";
import ColorSelector from "./ColorSelector";
import IconSelectorDialog from "./IconSelectorDialog";
import FormField from "./FormField";
import SimpleForm from "./SimpleForm";
import ColorSelectorBtn from "./ColorSelectorBtn";
import FormSelectorField from "./FormSelectorField";
import FormTextAreaField from "./FormTextAreaField";
import LinkText from "./LinkText";
import FormAutoComplete from "./FormAutoComplete";
import VC from './VC';
import FormDateSelector from "./FormDateSelector";
import FormTimeSelector from "./FormDateTimeSelector";
import PageDataTable from "./PageDataTable";
import FormSwitch from "./FormSwitch";
import Gap from "./Gap";
import FormDialog from "./FormDialog";
import JSONViewer from "./JSONViewer";
import FormExpression from "./FormExpression";
import LovDialog from "./LovDialog";
import FormFileInput from "./FormFileInput";
import FormImage from "./FormImage";

Vue.component('v-edit-delete-group', EditDeleteGroup);
Vue.component('v-vc', VC);
Vue.component('v-simple-table', SimpleTable);
Vue.component('v-icon-selector', IconSelector);
Vue.component('v-icon-selector-dialog', IconSelectorDialog);
Vue.component('v-color-selector', ColorSelector);
Vue.component('v-form-field', FormField);
Vue.component('v-form-date-selector', FormDateSelector);
Vue.component('v-form-time-selector', FormTimeSelector);
Vue.component('v-form-selector', FormSelectorField);
Vue.component('v-form-textarea', FormTextAreaField);
Vue.component('v-form-autocomplete', FormAutoComplete);
Vue.component('v-form-switch', FormSwitch);
Vue.component('v-form-expression', FormExpression);
Vue.component('v-simple-form', SimpleForm);
Vue.component('v-color-selector-btn', ColorSelectorBtn);
Vue.component('v-link-text', LinkText);
Vue.component('v-page-data-table', PageDataTable);
Vue.component('v-gap', Gap);
Vue.component('v-form-dialog', FormDialog);
Vue.component('v-json-viewer', JSONViewer);
Vue.component('v-lov-dialog', LovDialog);
Vue.component('v-form-file', FormFileInput);
Vue.component('v-form-image', FormImage);